import React, { useState } from "react";
import {
  ListSubheader,
  Box,
  List,
  styled,
  Button,
  ListItem,
  Collapse,
  ListItemIcon,
} from "@mui/material";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import routes, { EBaseRoutes, IRouteItemProps } from "../../const/routes";
import { IPrivilege } from "../../interfaces/privilege";
import { IRootState } from "../../store/configureStore";
import hasPrivilege from "../../util/hasPermission";
import { useSelector } from "react-redux";

const MenuWrapper = styled(Box)`
  .MuiList-root {
    padding: 8px;
  }

  .MuiListSubheader-root {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    padding: 0 20px;
    line-height: 1.4;
    cursor: pointer;
  }
`;

const SubMenuWrapper = styled(Box)`
  .MuiList-root {
    .MuiListItem-root {
      padding: 1px 0;

      .MuiButton-root {
        display: flex;
        color: rgba(255, 255, 255, 0.7);
        background-color: transparent;
        width: 100%;
        justify-content: flex-start;
        padding: 10px 24px;

        .MuiButton-startIcon {
          color: rgba(255, 255, 255, 0.3);
          font-size: 20px;
          margin-right: 8px;
        }

        &.active,
        &:hover {
          background-color: rgba(255, 255, 255, 0.06);
          color: #fff;

          .MuiButton-startIcon {
            color: #fff;
          }
        }
      }
    }
  }
`;

function SidebarMenu() {
  const [openSection, setOpenSection] = useState<string | null>(null);
  const location = useLocation();

  const toggleSection = (section: string) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  type NavItemProps = {
    title: string;
    itemId: string;
    elemBefore?: React.FC<unknown>;
    subNav?: NavItemProps[];
  };

  const getSubRoutes = (
    items: IRouteItemProps[],
    privileges: IPrivilege[]
  ): NavItemProps[] => {
    return items
      .filter((item) => item.isNavBarItem && hasPrivilege(privileges, item.id))
      .map((item) => {
        return {
          title: item.title,
          itemId: item.path,
        };
      });
  };

  const { privileges } = useSelector(({ privileges }: IRootState) => ({
    privileges: privileges.dataBundle,
  }));

  return (
    <MenuWrapper>
      <List component="div">
        {routes(location).map((item) => {
          const { title, itemId, elemBefore, subItems } = item;
          const subNav = getSubRoutes(subItems, privileges);
          const isActive = location.pathname.startsWith(itemId);
          const isOpen = openSection === title;

          return (
            <React.Fragment key={itemId}>
              {/* Main Menu Item */}
              <List component="div">
                <ListSubheader
                  component="div"
                  disableSticky
                  onClick={() => toggleSection(title)}
                  sx={{
                    backgroundColor:
                      isActive || isOpen
                        ? "rgba(217, 217, 217, 0.3)"
                        : "transparent",
                    borderRadius: "10px",
                    height: "40px",
                    marginLeft: "20px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 10px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginRight: "9px",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: "30px",
                      color: "white",
                    }}
                  >
                    {React.createElement(elemBefore)}
                  </ListItemIcon>
                  {title}
                </ListSubheader>

                {/* Submenu Collapse */}
                {subNav && subNav.length > 0 && (
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <SubMenuWrapper>
                      <List component="div">
                        {subNav.map(({ title: subItemTitle, itemId }) => (
                          <ListItem component="div" key={itemId}>
                            <Button
                              disableRipple
                              component={RouterLink}
                              to={itemId}
                              sx={{
                                "&.active": {
                                  backgroundColor: "rgba(217, 217, 217, 0.3)",
                                  borderRadius: "10px",
                                  color: "white",
                                },
                                marginLeft: "40px",
                              }}
                              className={
                                location.pathname === itemId ? "active" : ""
                              }
                            >
                              {subItemTitle}
                            </Button>
                          </ListItem>
                        ))}
                      </List>
                    </SubMenuWrapper>
                  </Collapse>
                )}
              </List>
            </React.Fragment>
          );
        })}
      </List>
    </MenuWrapper>
  );
}

export default SidebarMenu;
// import React, { useState } from "react";
// import {
//   ListSubheader,
//   Box,
//   List,
//   styled,
//   ListItem,
//   Collapse,
//   ListItemIcon,
// } from "@mui/material";
// import { NavLink as RouterLink, useLocation } from "react-router-dom";
// import routes, { IRouteItemProps } from "../../const/routes";
// import { IPrivilege } from "../../interfaces/privilege";
// import { IRootState } from "../../store/configureStore";
// import hasPrivilege from "../../util/hasPermission";
// import { useSelector } from "react-redux";
// import { Button } from "@mui/material";

// // Styled Components
// const MenuWrapper = styled(Box)`
//   .MuiList-root {
//     padding: 8px;
//   }

//   .MuiListSubheader-root {
//     text-transform: uppercase;
//     font-weight: bold;
//     font-size: 12px;
//     color: rgba(255, 255, 255, 0.5);
//     padding: 0 20px;
//     line-height: 1.4;
//     cursor: pointer;
//   }
// `;

// const SubMenuWrapper = styled(Box)`
//   .MuiList-root {
//     .MuiListItem-root {
//       padding: 1px 0;

//       .MuiButton-root {
//         display: flex;
//         color: rgba(255, 255, 255, 0.7);
//         background-color: transparent;
//         width: 100%;
//         justify-content: flex-start;
//         padding: 10px 24px;

//         .MuiButton-startIcon {
//           color: rgba(255, 255, 255, 0.3);
//           font-size: 20px;
//           margin-right: 8px;
//         }

//         &.active,
//         &:hover {
//           background-color: rgba(255, 255, 255, 0.06);
//           color: #fff;

//           .MuiButton-startIcon {
//             color: #fff;
//           }
//         }
//       }
//     }
//   }
// `;

// function SidebarMenu() {
//   const [openSection, setOpenSection] = useState<string | null>(null);
//   const location = useLocation();

//   // Get privileges from Redux store
//   const { privileges } = useSelector(({ privileges }: IRootState) => ({
//     privileges: privileges.dataBundle,
//   }));

//   // Filter routes based on privileges
//   const getFilteredRoutes = (
//     routes: IRouteItemProps[],
//     privileges: IPrivilege[]
//   ) => {
//     return routes.filter(
//       (item) => item.isNavBarItem && hasPrivilege(privileges, item.id)
//     );
//   };

//   const filteredRoutes = getFilteredRoutes(
//     routes(location).map((route) => ({
//       ...route,
//       path: route.itemId,
//       isNavBarItem: !!route.subItems,
//       route: route.itemId,
//       element: route.elemBefore ? React.createElement(route.elemBefore) : null,
//     })),
//     privileges
//   );

//   // Toggle section open/close
//   const toggleSection = (section: string) => {
//     setOpenSection((prev) => (prev === section ? null : section));
//   };

//   return (
//     <MenuWrapper>
//       <List component="div">
//         {filteredRoutes.map(({ title, itemId, elemBefore, subItems }) => {
//           const isActive = location.pathname.startsWith(itemId!!);
//           const isOpen = openSection === title;

//           return (
//             <React.Fragment key={itemId}>
//               {/* Main Menu Item */}
//               <List component="div">
//                 <ListSubheader
//                   component="div"
//                   disableSticky
//                   onClick={() => toggleSection(title)}
//                   sx={{
//                     backgroundColor:
//                       isActive || isOpen
//                         ? "rgba(217, 217, 217, 0.3)"
//                         : "transparent",
//                     borderRadius: "10px",
//                     height: "40px",
//                     marginLeft: "20px",
//                     color: "white",
//                     display: "flex",
//                     alignItems: "center",
//                     padding: "0 10px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     marginRight: "9px",
//                   }}
//                 >
//                   <ListItemIcon
//                     sx={{
//                       minWidth: "30px",
//                       color: "white",
//                     }}
//                   >
//                     {elemBefore && React.createElement(elemBefore)}
//                   </ListItemIcon>
//                   {title}
//                 </ListSubheader>

//                 {/* Submenu Collapse */}
//                 {subItems && subItems.length > 0 && (
//                   <Collapse in={isOpen} timeout="auto" unmountOnExit>
//                     <SubMenuWrapper>
//                       <List component="div">
//                         {subItems.map(({ title: subItemTitle, path, id }) => (
//                           <ListItem component="div" key={id}>
//                             <Button
//                               disableRipple
//                               component={RouterLink}
//                               to={path}
//                               sx={{
//                                 "&.active": {
//                                   backgroundColor: "rgba(217, 217, 217, 0.3)",
//                                   borderRadius: "10px",
//                                   color: "white",
//                                 },
//                                 marginLeft: "40px",
//                               }}
//                               className={
//                                 location.pathname === path ? "active" : ""
//                               }
//                             >
//                               {subItemTitle}
//                             </Button>
//                           </ListItem>
//                         ))}
//                       </List>
//                     </SubMenuWrapper>
//                   </Collapse>
//                 )}
//               </List>
//             </React.Fragment>
//           );
//         })}
//       </List>
//     </MenuWrapper>
//   );
// }

// export default SidebarMenu;
